import React, { ReactNode, useEffect } from "react";
import { useErrorStore } from "../store/errorStore";
import ErrorScreen from "./ErrorScreen";

export default function GlobalErrorBoundary({ children }: { children: ReactNode }) {
    const { error, setError } = useErrorStore();
    useEffect(() => {
        return () => {
            setError(null);
        }
    }, [])
    if (error) {
        return <ErrorScreen/>;
    }

    return <>{children}</>;
}
